import React, {useState, useEffect} from 'react';
import Modal from 'react-bootstrap/Modal';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import { BsFileEarmarkPdf } from 'react-icons/bs';
import { BiVideo } from 'react-icons/bi';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Player, BigPlayButton } from 'video-react';
import { convertSecToMinute } from '../../../../../utils/useWindowDimensions';
import ProSOPImage from '../../../../../assets/images/pro/ProSopImage.png';
import { Worker } from '@react-pdf-viewer/core';
import { Viewer, SpecialZoomLevel } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';

const apiUrl={
    "XR":{
        "sopPath" : "api/resource/module/sop"
    },
    "2D":{
        "sopPath" : "api/resource/2d/lms/sop"
    },
}

const SOP = ({ userPlan, setShowTab, MODE }) => {
    let params = useParams();
    const moduleUUID = params.uuid;
    const userData = useSelector((state) => state.userSlice); 
    const configData = useSelector((state) => state.configSlice);
    const [sopList, setSopList] = useState([]);

    const transform = (slot) => ({
        ...slot,
        Download: () => <></>,
        DownloadMenuItem: () => <></>,
        // EnterFullScreen: () => <></>,
        // EnterFullScreenMenuItem: () => <></>,
        SwitchTheme: () => <></>,
        SwitchThemeMenuItem: () => <></>,
        Open: () => <></>,
        Print: () => <></>,
        ShowProperties: () => <></>,
        ShowPropertiesMenuItem: () => <></>,
        // ZoomIn: () => <></>,
        // ZoomOut: () => <></>,
    });

    const toolbarPluginInstance = toolbarPlugin();
    const { renderDefaultToolbar } = toolbarPluginInstance;
    const renderToolbar = (Toolbar) => (
        <Toolbar>{renderDefaultToolbar(transform)}</Toolbar>
    );

    const defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar,
        sidebarTabs: (defaultTabs) => [
            defaultTabs[0], 
        ],
    });

    const renderSopItem = (sopItem, index) => {
        if (sopItem.fileType === 'image') {
            return (
                <Tab.Pane key={index} eventKey={`sop${index}`}>
                    <img src={sopItem.path} alt="" width="100%" height="100%" />
                </Tab.Pane>
            );
        } else if (sopItem.fileType === 'pdf') {
            return (
                <Worker workerUrl="https://cdn.simulanis.io/sso/external/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                    <Tab.Pane key={index} eventKey={`sop${index}`}>
                        <Viewer
                            fileUrl={sopItem.path}
                            plugins={[defaultLayoutPluginInstance]}
                        />
                    </Tab.Pane>
                </Worker>
            );
        } else if (sopItem.fileType === 'video') {

            const handleContextMenu = (e) => {
                e.preventDefault(); 
            };
            
            return (
                <Tab.Pane key={index} eventKey={`sop${index}`}>
                    <video controls width="100%" height="100%" onContextMenu={handleContextMenu}>
                        <source src={sopItem.path} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </Tab.Pane>
            );
        }
        return null;
    };

    const getFileTypeFromName = (filename) => {
        const extension = filename?.split('.').pop().toLowerCase();
    
        if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'gif') {
          return 'image';
        } else if (extension === 'mp4' || extension === 'avi' || extension === 'mov') {
          return 'video';
        } else if (extension === 'mp3' || extension === 'wav' || extension === 'ogg') {
          return 'audio';
        } else if (extension === 'pdf') {
          return 'pdf';
        } else if (extension === 'doc' || extension === 'docx') {
          return 'docx';
        } else if (extension === 'ppt' || extension === 'pptx') {
          return 'pptx';
        } else if (extension === 'xls' || extension === 'xlsx') {
          return 'xlsx';
        } else {
          return 'unknown';
        }
      }

    const getModuleSop = async () => {
        try {
          let response = await axios.get(`${configData.config.UNO_URL}/${apiUrl[MODE].sopPath}/${moduleUUID}`, {
            headers: {
              Authorization: `Bearer ${userData.token}`,
              "Content-Type": "application/json"
            }
          });
          let dataList = response?.data?.data?.children[0]?.versions[0]?.data?.docs || [];
          if (dataList?.length > 0) {
            for (let i = 0; i < dataList?.length; i++) {
              const fileType = getFileTypeFromName(dataList[i].path);
              dataList[i].fileType = fileType;
            }
          }
          setSopList([...dataList]);
          if(dataList.length > 0) setShowTab();
    
        } catch (error) {
          console.log(error);
        }
    
      }

    useEffect(() => {
          getModuleSop();
        },[]);


    return (
        <div className='container'>
            {sopList.length > 0 ? (
                userPlan?.courseDetail?.sop ? (
                    <div className='module-frame'>
                        <Tab.Container defaultActiveKey="sop0">
                            <div className='playscreen'>
                                <div className='frame-parent' style={{ backgroundColor: "#ffffff", boxShadow: "none" }}>
                                    <Tab.Content className='sop-tab-content'>
                                        {sopList.map(renderSopItem)}
                                    </Tab.Content>
                                </div>
                            </div>
                            <div className='module-info'>
                                <div className='video-list'>
                                    <div className='video-list-scroll forsop'>
                                        <Nav variant="pills" className="flex-column">
                                            {sopList.map((sopItem, index) => (
                                                <Nav.Item key={index}>
                                                    <Nav.Link eventKey={`sop${index}`}>
                                                        {sopItem.fileType === 'image' && (
                                                            <div className='sop-list-item'>
                                                                <img src={sopItem.path} className='img-thumbnail' alt="" />
                                                                <p className='sopname'>{sopItem.name}</p>
                                                                </div>
                                                            )}
                                                            {sopItem.fileType === 'pdf' && (
                                                                <>
                                                                <div className='sop-list-item'>
                                                                <span className='pdfsop'><BsFileEarmarkPdf /></span>
                                                                <p className='sopname'>{sopItem.name}</p>
                                                                </div>
                                                                </>
                                                            )}
                                                            {sopItem.fileType === 'video' && (
                                                                <>
                                                                <div className='sop-list-item'>
                                                                <span className='videosop'><BiVideo /> </span>
                                                                <p className='sopname'>{sopItem.name}</p>
                                                                </div>
                                                                </>
                                                            )}
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                ))}
                                            </Nav>
                                </div>
                                </div>
                            </div>
                        </Tab.Container>
                    </div>
                ) : (
                    <div className='for-pro' style={{ aspectRatio: "auto" }}>
                        <img src={ProSOPImage} />
                        <span className='cover-up'></span>
                        <div className='unlock-data'>
                            <h6>Unlock Features</h6>
                            <p>To access these additional features, <br />
                                please <a> upgrade your plan. </a>
                            </p>
                            <button>Upgrade Plan</button>
                        </div>
                    </div>
                )
            ) : (
                <p>No document found.</p>
            )}
        </div>
    );
};

export default SOP;
